import {
	PanelDetailDiv,
	SQMobileViewWrap,
	MobileViewWrap,
	DivSolarImagery,
	SideModalArrowbutton,
	RightSidePanel,
	DivSidePanelWrap,
	PanelDetailDefaultView,
	EditModeEnabledwrap
} from './style';
import { forwardRef, useState } from 'react';
import { DESIGN_MODES, SUBHUB_APP_NAME } from '../../../../constants';
import { EnergyState } from 'store/slices/EnergySlice/types';
import AllPanelsToggle from '../../AllPanelsToggle';
import {
	AdjustPanelColorToggle,
	AnnualUsage,
	ChangePanelSelector,
	ElectricBillInput,
	Offset,
	Production,
	SaveDesignBtn,
	SystemSize
} from '../../PanelComponent';
import DesignModesSelector from 'components/ModeSelector';
import ShowSetback from '../../SetbackToggle';
import EdgeLenghtToggle from '../../EdgeLengthToggle';
import { EditFacetModalBtnWrap } from 'components/ManualToolModal/style';
import { UseQueryResult } from 'react-query';
import FacetListButton from 'components/ManualToolModal/facetListBtn';
import ImageryDate from 'components/DisplayEnergy/ImageryDate';
import {ImageryIcon, SolarDataIcon } from 'assets/svg';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import DisplayModal from 'components/DisplayModal/DisplayModal';
import { InteractionBlocker } from 'components/InteractionBlocker/interactionBlockerLayer';
import CustomMapSelect from 'components/CustomMapSelect';
import { isInHouseSimulationMode } from '../../../../util';

interface SolarMobileViewProps {
	saveStatus: { isLoading: boolean; isError: boolean };
	getPanelDetailsForOrg: UseQueryResult<any, unknown>;
	savePanels: () => void;
}

const SolarMobileView = forwardRef<HTMLDivElement, SolarMobileViewProps>(
	(props, ref) => {
		const { saveStatus, getPanelDetailsForOrg, savePanels } = props;
		const energy = useSelector((state: RootState) => state.energyData.data as unknown as EnergyState);
		const { uuid, roofSegsFromWhichUserHasSelectedPanels, panel, org, selectedPanelKey, mode, imageryCapturedDate, solarDataCapturedDate,
			roofDataChanging, autoSwitchStatus, billingLogs, modeAndItsCorrespondingImagery, roofDesignMode, panelsKeysForWhichDesignIsAvailable }
			= useSelector((state: RootState) => ({
				...state.roofData.data,
				roofDataChanging: state.roofData.configuringNewPanel || state.roofData.loading || state.roofData.switchingImageryProvider
			}));
		const { parentAppName, energyDerateRate, stateCode, showLidarDate: showLidarDateParam } =
			useSelector((state: RootState) => state.QueryParams.data);
		const showLidarDate = showLidarDateParam && !isInHouseSimulationMode(mode);
		const minPanelsRequiredForDesignToQualify = org.setting.minPanelsRequiredForDesignToQualify;
		const [error, setError] = useState<boolean>(false);
		const { roofIndexes, editModeEnabled } = useSelector((state: RootState) => state.toolNewPostions.data);
		const isParentNotEmbeddedInSubHub = parentAppName !== SUBHUB_APP_NAME;
		const someFacetIsStillInEditMode = roofSegsFromWhichUserHasSelectedPanels.filter(ind => roofIndexes.includes(ind));
		const disableOnEdit = editModeEnabled || !!someFacetIsStillInEditMode.length;
		const showAllPanelsToggle = isParentNotEmbeddedInSubHub && org.setting.showToggleForAllPanels;
		const isInvalidDesignToProceed = energy.selectedPanels?.length < minPanelsRequiredForDesignToQualify;
		const [solarModalOpen, setSolarModalOpen] = useState(false);
		const { fullScreenEnabled } = useSelector((state: RootState) => state.toolNewPostions.data);

		return (
			<RightSidePanel
				ref={ref}
				className={` mobile-sidepanel avi 
				${fullScreenEnabled ? 'fullScreenView' : 'defaultScreenView'} 
				${org.setting.isB2C ? 'b2cView' : ''}`}>
				{!solarModalOpen &&
				<DivSidePanelWrap>
					<PanelDetailDefaultView className='side-solar-defaultview'>
						<SystemSize energy={energy} />
						<Production energy={energy} />
						<Offset energy={energy} />
						
						{!org.setting.isB2C && (
							<SideModalArrowbutton onClick={() => setSolarModalOpen(true)} className='solarbtn-sidepanel'>
								<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 52 52" fill="none">
									<circle cx="26" cy="26" r="25" fill="var(--defaultBgColor)" stroke="#CCD0D7" />
									<path d="M19 26.5L26.5 19L34 26.5" stroke="var(--defaultIconColor)"
										strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
									<path d="M19 33.5L26.5 26L34 33.5" stroke="var(--defaultIconColor)"
										strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
								</svg>
							</SideModalArrowbutton>
						)}
					</PanelDetailDefaultView>
				</DivSidePanelWrap>
				}
				<DisplayModal open={solarModalOpen} handleClose={() => setSolarModalOpen(false)} className="modal-custom-class sidepanel-modal">
					<MobileViewWrap className='sm-screen solar-sm-screen'> 
						<SideModalArrowbutton onClick={() => setSolarModalOpen(false)} className='solarbtn-sidepanel sidepanel-model-close'>
							<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 52 52" fill="none">
								<circle cx="26" cy="26" r="25" fill="var(--defaultBgColor)" stroke="#CCD0D7" />
								<path d="M19 25.5L26.5 33L34 25.5" stroke="var(--defaultIconColor)" strokeWidth="1.5" 
									strokeLinecap="round" strokeLinejoin="round" />
								<path d="M19 18.5L26.5 26L34 18.5" stroke="var(--defaultIconColor)" strokeWidth="1.5" 
									strokeLinecap="round" strokeLinejoin="round" />
							</svg>
						</SideModalArrowbutton>
						<InteractionBlocker>
							{(showAllPanelsToggle || !org.setting.isB2C) && <PanelDetailDiv
								className="design-mode-panel"
							>	
								<DesignModesSelector
									designMode={mode}
									roofMode={roofDesignMode}
									designUUID={uuid}
									panelKey={panel.key}
									energyDerateRate={energyDerateRate}
									stateCode={stateCode}
									billingLogs={billingLogs}
									autoSwitchStatus={autoSwitchStatus}
									modeAndItsCorrespondingImagery={modeAndItsCorrespondingImagery}
								/>
								<EditFacetModalBtnWrap>
									<FacetListButton onclick={() => setSolarModalOpen(false)} />
								</EditFacetModalBtnWrap>

								<DivSolarImagery className='solar-imagery-wrap'>
									<ImageryDate label="Imagery" date={imageryCapturedDate} 
										icon={<ImageryIcon width="38" height="38" />} />
									{showLidarDate && <ImageryDate label="Solar Data" date={solarDataCapturedDate} 
										icon={<SolarDataIcon width="38" height="38" />} />}
								</DivSolarImagery>
				
								{showAllPanelsToggle && <AllPanelsToggle />}
							</PanelDetailDiv>}
							<MobileViewWrap className='two'>
								<PanelDetailDiv className='PanelwidthAuto 1'>
									<SystemSize energy={energy} />
									<Production energy={energy} />
									<Offset energy={energy} />
								</PanelDetailDiv>
								<PanelDetailDiv className='bill-annual-wrap'>
									<ElectricBillInput setError={setError} />
									{org.setting.acceptsAnnualEnergy && <AnnualUsage setError={setError} isMobileView={true} />}
								</PanelDetailDiv>
								<PanelDetailDiv className="change-panel-wrap">
									<ChangePanelSelector
										getPanelDetailsForOrgData={getPanelDetailsForOrg.data}
										selectedPanelKey={selectedPanelKey}
										panelsKeysForWhichDesignIsAvailable={panelsKeysForWhichDesignIsAvailable}
									/>
								</PanelDetailDiv>

								{mode === DESIGN_MODES.NEARMAP_NREL_MANUAL && (
									<PanelDetailDiv className="change-panel-wrap">
										<CustomMapSelect/>
									</PanelDetailDiv>
								)}
								{<PanelDetailDiv className='adjustSetback-wrap'>

									{!editModeEnabled ?
										<AdjustPanelColorToggle />
										:
										<EditModeEnabledwrap>
											<ShowSetback />
											<EdgeLenghtToggle />
										</EditModeEnabledwrap>
									}
								</PanelDetailDiv>}

								{/* {!org.setting?.isB2C && <PanelDetailDiv>
															<RecommendPanelsButton/>}
															</PanelDetailDiv> */}
								<SaveDesignBtn
									isB2C={false}
									designUUID={uuid}
									disabled={error || disableOnEdit || roofDataChanging || isInvalidDesignToProceed}
									onClick={savePanels}
									tooltipContent={isInvalidDesignToProceed ? `Atleast ${minPanelsRequiredForDesignToQualify} ${minPanelsRequiredForDesignToQualify<2 ? 'panel is' : 'panels are'} required to proceed.` : ''}
									id="save-design-solar-mobile"
									status={saveStatus}
								/>
							</MobileViewWrap>
						</InteractionBlocker>
					</MobileViewWrap>
				</DisplayModal>
			</RightSidePanel>
		);
	});
SolarMobileView.displayName = 'SolarMobileView';	
export default SolarMobileView;
